interface State {
  ids: string[];
  state: 'beforeStart' | 'recording' | 'afterEnd';
}

function domWalk(node: Element, idA: string, idB: string, state: State) {
  if (state.state == 'beforeStart') {
    if (node.id === idA || node.id === idB) {
      state.state = 'recording';
      state.ids.push(node.id);
      return;
    }
  }

  if (state.state === 'afterEnd') {
    return;
  }

  if (state.state == 'recording') {
    if (node.id === idA || node.id === idB) {
      state.state = 'afterEnd';
    }
    if (node.id) {
      state.ids.push(node.id); // inclusive, in ending case
      return;
    }
  }

  for (const child of node.childNodes) {
    if (child.nodeType === Node.ELEMENT_NODE) {
      domWalk(child as Element, idA, idB, state);
    }
  }
}

export function idsBetween(startId: string, endId: string) {
  const ids: string[] = [];
  domWalk(document.body, startId, endId, { ids: ids, state: 'beforeStart' });
  return ids;
}
